import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-609feb77"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg-white d-flex flex-column flex-grow-1 justify-content-center align-items-center px-4 p-sm-0",
  style: {"flex-basis":"0"}
}
const _hoisted_2 = { class: "d-sm-none" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fw-boldest fs-4x" }, "Login")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-gray-500 fw-bold fs-1" }, [
    /*#__PURE__*/_createTextVNode(" Welcome back! "),
    /*#__PURE__*/_createElementVNode("span", { class: "fw-normal" }, "Please login to your account.")
  ])
], -1))
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "form-label fs-1 fw-bolder mb-4"
}, "Username", -1))
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label fw-bolder fs-1 mb-4"
}, "Password", -1))
const _hoisted_9 = {
  key: 0,
  class: "text-danger text-center fs-2 mt-8"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-lg btn-w-green text-white w-100 mt-12 py-4 fs-1",
  name: "login button"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Login "),
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
    /*#__PURE__*/_createTextVNode(" Please wait... "),
    /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_component_inline_svg, {
        class: "w-100",
        src: "media/logos/login-logo.svg"
      })
    ]),
    _createVNode(_component_Form, {
      class: "form",
      onSubmit: _ctx.onSubmitLogin
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Field, {
            id: "username",
            class: "form-control form-control-lg py-5",
            type: "text",
            name: "username",
            placeholder: "Username",
            autocomplete: "off"
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Field, {
            id: "password",
            class: "form-control form-control-lg py-5",
            type: "password",
            name: "password",
            placeholder: "Password",
            autocomplete: "off"
          }),
          (_ctx.errors.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errors), 1))
            : _createCommentVNode("", true),
          _hoisted_10
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}